(function(config) {
    'use strict';

    angular.module('page.services', [
            'ngResource'
        ])
        .factory('pageDataSrvc', pageDataSrvc)
        .factory('pageSrvc', pageSrvc);

    pageDataSrvc.$inject = ['$resource'];

    function pageDataSrvc($resource) {
        return $resource(config.api + '/api/v1/pages/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            menuOptions: {
                method: 'GET',
                url: config.api + '/api/v1/pages/admin_menu_options/',
                isArray: true
            },
            typeOptions: {
                method: 'GET',
                url: config.api + '/api/v1/pages/admin_type_options/',
                isArray: true
            },
            layoutOptions: {
                method: 'GET',
                url: config.api + '/api/v1/pages/admin_layout_options/',
                isArray: true
            },
            layoutOptionsClasses: {
                method: 'GET',
                url: config.api + '/api/v1/pages/admin_layout_options_classes/'
            },
            productPages: {
                method: 'GET',
                url: config.api + '/api/v1/pages/admin_product_pages/',
                isArray: true
            },
            bannerPages: {
                method: 'GET',
                url: config.api + '/api/v1/pages/admin_banner_pages/',
                isArray: true
            }
        });
    }

    pageSrvc.$inject = ['pageDataSrvc', 'modalSrvc'];

    function pageSrvc(pageDataSrvc, modalSrvc) {

        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    pageDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }
})(window.config);
